import React from 'react';
import moment from 'moment';

const Footer = () => {
    return (
        // <div className="wrapper d-flex align-items-center" style={{ height: '40px' }}>
        //     <span>
        //         Ozmosys <i className="far fa-copyright" /> {moment().format('YYYY')}
        //     </span>
        // </div>
        <footer className="footer d-flex align-items-center">
            <span>
                Ozmosys <i className="far fa-copyright" /> {moment().format('YYYY')}
            </span>
        </footer>
    );
};

export default Footer;
